export const CSRF_TOKEN = document.querySelector("[name='csrf-token']")?.content

// Required for POST requests
export const HEADERS = {
  'X-CSRF-Token': document.querySelector("[name='csrf-token']")?.content,
  'Content-Type': 'application/json',
  Accept: 'application/json'
}

export const HEADERS_TOKEN = {
  'X-CSRF-Token': document.querySelector("[name='csrf-token']")?.content
}

export const ENTITIES_TYPES = {
  employee: 'employees',
  candidate: 'candidates'
}

export const DEFAULT_PAGE_SIZE = 20
export const INFINITY_PAGE_SIZE = 100
export const API_PAGE_SHIFT = 1

/**
 * IMPORTANT:
 * Export it as a function,
 * because translations are not replaced by the I18n if you export it as a regular constant
 */
export const getTableMessages = () => ({
  noData: I18n.t('table.no_data'),
  rowsPerPage: I18n.t('table.rows_per_page'),
  pageNumber: I18n.t('table.page_number'),
  pageOf: (currentPage, total) => I18n.t(
    'table.page_of', { current_page: currentPage, total }
  ),
  resultOf: (currentResults, total) => I18n.t(
    'table.result_of', { current_results: currentResults, total }
  )
})

export const nullOption = {
  id: null,
  name: '\xa0' // Non-breakable space is char 160
}

// react-bootstrap's Overlay `flip` boolean prop silently disables a custom flip
// modifier in popperConfig, so callers must pass both `flip` and this config.
export const POPPER_CONFIG = {
  modifiers: [
    { name: 'flip', options: { boundary: 'viewport' } },
    { name: 'preventOverflow', options: { boundary: 'viewport' } }
  ]
}

// ========================== ECharts ========================== //

export const ECHARTS_BASE_COLORS = [
  '#2f7ed8',
  '#0d233a',
  '#8bbc21',
  '#910000',
  '#1aadce',
  '#492970',
  '#f28f43',
  '#77a1e5',
  '#c42525',
  '#a6c96a',
  '#e8bb23',
  '#2dd3ca',
  '#883ac9',
  '#98a5a6',
  '#e07520',
  '#1a43c9',
  '#39c96e',
  '#e66d73',
  '#9d8f00',
  '#c91dc6',
  '#232918',
  '#6ba6c9',
  '#2f7110',
  '#edf015'
]

export const ECHARTS_PIE_COLORS = [
  '#C686F8',
  '#528BFF',
  '#69D7F0',
  '#69D4AE',
  '#A6EF67',
  '#FFD063',
  '#FF9675',
  '#FF86C8'
]
